import { ComponentRef, ViewContainerRef } from '@angular/core';
import { RegisteFormSessionComponent } from './register.component';

class RegisterFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  // currentHandler: (response: com.ts.mobile.sdk.InputOrControlResponse<any>) => void;
  viewContainerRef: ViewContainerRef;
  registeFormSessionComponentRef: ComponentRef<RegisteFormSessionComponent>;

  constructor(formId: string, payload: object) {
      this.formId = formId;
      this.payload = payload;
  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

  }
  endSession(): void {
  }
  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    this.viewContainerRef.clear();

    this.registeFormSessionComponentRef = this.viewContainerRef.createComponent(RegisteFormSessionComponent);

    this.registeFormSessionComponentRef.instance.onSubmitUserEmail = this.onSubmitEmailRegister.bind(this);
    this.registeFormSessionComponentRef.instance.onRegisterskipClick = this.onRegisterSkip.bind(this);
    this.registeFormSessionComponentRef.instance.onSignInClick = this.onSignInClick.bind(this);

    const journeyPayload = this.payload as JourneyPayload;


    return new Promise((resolve, reject) => {
      this.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          this.submitBlock = null; // prevent reuse of a settled promise
        } catch (e) {
          console.error(e);
        }
      };
    });
  }
  onContinue(payload: object): void {
  }
  onError(payload: object): void {
    const userId = this.clientContext['cookieService'].get('register-email');

    const errorPayload = payload as JourneyPayload;
    const errorCode = errorPayload.code;

    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];

    if (errorCode === 'UE01') { // user not recognized
      this.clientContext['cookieService'].set('registerErrorCode', errorCode ? errorCode : null, undefined, undefined, null, true, 'None');
    }
    else if ((errorCode === '0' || 'UE05') && errorPayload.stat === 'ok'){ // user already exists(verified) and user already registered
      this.clientContext['cookieService'].set('registerErrorCode', 'ECP5', undefined, undefined, null, true, 'None');
    }
    else if (errorPayload.code === 'RC01'){
      const code  = 'rc01';
      let appendChar = '?';
      if (url.includes('?'))
      {
          appendChar = '&';
      }
      window.location.href = url + appendChar + 'error=' + code + '&error_description=rc01'
      + '&lang=' + this.clientContext['cookieService'].get('lang')
      + '&state=' + state;
    }
    else if (errorPayload.code === 'FB01'){
      this.processRecaptchaFailure();
    }
}
   /** Non UIFormSession interface Functions */
  private onSubmitEmailRegister(payload: object) {
    const data = payload;
    this.clientContext['cookieService'].set('register-email', payload['username'], undefined, undefined, null, true, 'None');
    this.clientContext['cookieService'].set('registerUsername', data['username'], undefined, undefined, null, true, 'None');
    this.submitBlock(data);
  }

  private onRegisterSkip(){
    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'cancel_register';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=cancel_register'
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }

  private onSignInClick(){
    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'signIn';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=signIn'
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }

  private processRecaptchaFailure(){
    this.clientContext['cookieService'].set('registerUseRecaptchaV3', false, undefined, undefined, null, true, 'None');
    this.clientContext['cookieService'].set('registerReCaptchaVersion', 'V2', undefined, undefined, null, true, 'None');

    setTimeout(() => this.registeFormSessionComponentRef.instance.validateAndSubmit(), 10);
  }
}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default RegisterFormSession;